import { useMutation, useQuery, useQueryClient } from "@tanstack/react-query";
import {
  createResourceRolesPermissions,
  deleteResourceRoleAndPermissionById,
  fetchCurrentResourceRoleAndPermission,
  fetchResourceRoleAndPermissionsById,
  updateResourceRoleAndPermissionById,
  updateResourceRoleMembers,
} from "controller/api";
import {
  ApiErrorType,
  FetchResourceAndPermissionByIdInput,
  GetQueryProps,
} from "shared";
import { sentryLogger } from "utilz";
export const useCreateResourceRolesPermissions = () => {
  const queryClient = useQueryClient();
  return useMutation(createResourceRolesPermissions, {
    onSuccess: (_, variable, __) => {
      queryClient.invalidateQueries(["resourceType"]);
      queryClient.invalidateQueries(["resourcePermission"]);
    },
    onError(error: ApiErrorType, variables, context) {
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "createResourceRolesPermissions",
      });
    },
  });
};

export const useFetchResourceRoleAndPermissionsById = (
  data: FetchResourceAndPermissionByIdInput
) => {
  return useQuery({
    queryKey: ["resourcePermission", data.resource_type_id],
    enabled: !!data.resource_type_id,
    queryFn: () => fetchResourceRoleAndPermissionsById(data),
    onError: (error: ApiErrorType) =>
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "fetchResourceRoleAndPermissionsById",
      }),
  });
};

export const useFetchResourceRoleAndPermissionsByIdMutation = () => {
  const queryClient = useQueryClient();
  return useMutation(fetchResourceRoleAndPermissionsById, {
    onSuccess: (_, variable, __) => {},
    onError(error: ApiErrorType, variables, context) {
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "fetchResourceRoleAndPermissionsById",
      });
    },
  });
};

export const useUpdateResourceRoleAndPermissionById = () => {
  const queryClient = useQueryClient();
  return useMutation(updateResourceRoleAndPermissionById, {
    onSuccess: (_, variable, __) => {
      queryClient.invalidateQueries(["resourceType"]);
      queryClient.invalidateQueries(["resourcePermission"]);
    },
    onError(error: ApiErrorType, variables, context) {
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "updateResourceRoleAndPermissionById",
      });
    },
  });
};

export const useDeleteResourceRoleAndPermissionById = () => {
  const queryClient = useQueryClient();
  return useMutation(deleteResourceRoleAndPermissionById, {
    onSuccess: (_, variable, __) => {
      queryClient.invalidateQueries(["resourceType"]);
      queryClient.invalidateQueries(["resourcePermission"]);
    },
    onError(error: ApiErrorType, variables, context) {
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "deleteResourceRoleAndPermissionById",
      });
    },
  });
};

export const useFetchCurrentResourceRoleAndPermission = () => {
  return useQuery({
    queryKey: ["resourcePermission", "me"],
    queryFn: () => fetchCurrentResourceRoleAndPermission(),
    onError: (error: ApiErrorType) =>
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "fetchCurrentResourceRoleAndPermission",
      }),
  });
};

export const useUpdateResourceRoleMembers = () => {
  const queryClient = useQueryClient();
  return useMutation(updateResourceRoleMembers, {
    onSuccess: (_, variable, __) => {
      queryClient.invalidateQueries(["resources"]);
      queryClient.invalidateQueries(["resourceType"]);
      queryClient.invalidateQueries(["resourcePermission"]);
    },
    onError(error: ApiErrorType, variables, context) {
      sentryLogger({
        error: error,
        workflow: "controlCenter",
        level: "error",
        functionName: "updateResourceRoleMembers",
      });
    },
  });
};
